import {graphql} from 'react-relay'

export const federationServersQuery = graphql`
  query ProjectsPopupFederationServersQuery($skip: Boolean = false) {
    federationServers @skip(if: $skip) {
      ...projectTreesFederationServersFragment
    }
  }
`
